<template>
  <v-flex xs12>
    <about-tile
        v-if="canViewAboutTile"
        :can-view-about="canViewAbout"
        :can-view-chair="canViewChair"
        :can-view-sponsors="canViewSponsors"></about-tile>
    <waivers-tile v-if="displayWaiverTile" :community-type="routerNames.REGION"></waivers-tile>
    <filesand-media v-if="canViewFilesAndMedia"></filesand-media>
  </v-flex>
</template>

<script>
import AboutTile from '../ChapterPage/AboutTile/AboutTile';
import FilesandMedia from "../ChapterPage/FilesandMedia/FilesandMedia";
import { mapGetters } from "vuex";
import { storeGetters } from "../../store/storeGetters.constant";
import WaiversTile from "../ChapterWaiver/ChapterWaiverTile";
import communityLeftSideBarMixin from "../../mixins/communityLeftSideBarMixin";
import { routerNames } from "../appCommon.constants";

export default {
  name: 'RegionLeftSidebar',
  mixins: [communityLeftSideBarMixin],
  data: () => {
    return {
      routerNames,
      ypoGold: 'YPO Gold',
      regionalDirector: 'Regional Director',
    };
  },
  components: {
    AboutTile,
    FilesandMedia,
    WaiversTile,
  },
  computed: {
    ...mapGetters({
      usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
      profileInfo: `myAccount/${storeGetters.profileInformation}`,
      prpRole: `chapterWaiver/${storeGetters.prpRole}`,
    }),
    isVisible() {
      return this.$route.params.communityId !== undefined;
    },
    canViewFilesAndMedia() {
      return this.communityInfo &&
          this.communityInfo.communityId === this.$route.params.communityId &&
          this.communityInfo.userAccess &&
          this.communityInfo.userAccess.canViewAllFilesAndMedia;
    },
    isRegionPage() {
      return this.$route.name === this.routerNames.REGION;
    },
    isYpoGoldMember() {
      return this.profileInfo && this.profileInfo.ypowpoformula && this.profileInfo.ypowpoformula === this.ypoGold;
    },
    isRegionalDirector() {
      return this.usersCommunitiesList && this.usersCommunitiesList && this.usersCommunitiesList.some(x => x.communityId === this.$route.params.communityId && x.userAccess.userCommunityRole === this.regionalDirector);
    },
    hasSpecialPermissionForWaivers() {
      let hasPermission = false;
      if (this.prpRole && this.prpRole.regionalWaiverAccessList && this.prpRole.regionalWaiverAccessList.length && this.$route.params.communityId) {
        hasPermission = !!(
            this.prpRole.regionalWaiverAccessList
                .find(region => region.regionId === this.$route.params.communityId && region.canAccessRegionalWaiver)
        );
      }
      return hasPermission;
    },
    displayWaiverTile() {
      const {
        isRegionPage,
        isVisible,
        isYpoGoldMember,
        canViewWaiversLink,
        isRegionalDirector,
        hasSpecialPermissionForWaivers,
      } = this;
      return (isRegionPage && isVisible && !isYpoGoldMember && canViewWaiversLink
          && !isRegionalDirector) || (isVisible && isRegionPage && hasSpecialPermissionForWaivers);
    },
  },
};
</script>
